export const CUSTOM_STYLE_NAME = "Your Custom Style";
export const DEFAULT_STYLE_NAME = "Story Bible Style";

export function getProjectTopBarSelectedStyleName({ selectedStyle, canonicalStyle, legacyStyle }) {
  if (
    (selectedStyle?.source === "story_bible" || selectedStyle?.source === "sudowrite" || selectedStyle?.source === "user_style") &&
    typeof selectedStyle.name === "string" &&
    selectedStyle.name.trim()
  ) {
    return selectedStyle.name.trim();
  }

  const resolvedStyle = canonicalStyle?.trim() || legacyStyle?.trim() || "";
  return resolvedStyle ? CUSTOM_STYLE_NAME : DEFAULT_STYLE_NAME;
}
